/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { networkIngressDeleteIngress } from "../funcs/networkIngressDeleteIngress.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  DeleteNetworkIngressRequest,
  DeleteNetworkIngressSecurity,
} from "../models/operations/deletenetworkingress.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type NetworkIngressDeleteIngressMutationVariables = {
  request?: DeleteNetworkIngressRequest | undefined;
  security?: DeleteNetworkIngressSecurity | undefined;
  options?: RequestOptions;
};

export type NetworkIngressDeleteIngressMutationData = void;

export type NetworkIngressDeleteIngressMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * deleteIngress networkIngress
 *
 * @remarks
 * Soft-delete the ingress and retain provider identities until cleanup is confirmed.
 */
export function useNetworkIngressDeleteIngressMutation(
  options?: MutationHookOptions<
    NetworkIngressDeleteIngressMutationData,
    NetworkIngressDeleteIngressMutationError,
    NetworkIngressDeleteIngressMutationVariables
  >,
): UseMutationResult<
  NetworkIngressDeleteIngressMutationData,
  NetworkIngressDeleteIngressMutationError,
  NetworkIngressDeleteIngressMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildNetworkIngressDeleteIngressMutation(client, options),
    ...options,
  });
}

export function mutationKeyNetworkIngressDeleteIngress(): MutationKey {
  return ["@gram/client", "networkIngress", "deleteIngress"];
}

export function buildNetworkIngressDeleteIngressMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: NetworkIngressDeleteIngressMutationVariables,
  ) => Promise<NetworkIngressDeleteIngressMutationData>;
} {
  return {
    mutationKey: mutationKeyNetworkIngressDeleteIngress(),
    mutationFn: function networkIngressDeleteIngressMutationFn({
      request,
      security,
      options,
    }): Promise<NetworkIngressDeleteIngressMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(networkIngressDeleteIngress(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
